module.exports = __webpack_public_path__ + "img/company-logo.2f1a3f62.svg";